module.exports = __webpack_public_path__ + "static/media/banner-1.e2d42920.glb";